export const environment = {

    production: false,
    serverUrl: 'https://xc46qksx73.execute-api.us-east-2.amazonaws.com/dev',
    bucket: 'script-prod-upload',
    userPool: {
      UserPoolId: 'us-east-2_YqQorQtES',
      ClientId: '6fs260gcjqvg2l0kt41pnllesn',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:586ca5af-282f-40df-b85a-276eaaf98ace',
    buckets: {
      'us-east-2': 'script-prod-upload'
    },
    modules: {
      key: 'analysisType',
      values: [
          {
            'name': 'qPCR',
            'desc': 'qPCR'
          }
      ]
  },
   version: 'version 2.0',
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId: 'us-east-2:586ca5af-282f-40df-b85a-276eaaf98ace', // REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_YqQorQtES', // OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '6fs260gcjqvg2l0kt41pnllesn', // OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'script-prod-upload',
        region: 'us-east-2', // OPTIONAL -  Amazon service region
      }
    }
  };
  const awsconfig = {
    'aws_project_region': 'us-east-2',
    'aws_cognito_region': 'us-east-2',
    'aws_user_pools_id': 'us-east-2_YqQorQtES',
    'aws_user_pools_web_client_id': '6fs260gcjqvg2l0kt41pnllesn',
    'aws_cognito_mfa_configuration': 'OPTIONAL',

  };
  export default awsconfig;


